import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import CategorySection from "./components/CategorySection";
import WhySection from "./components/WhySection";
import SeoContent from "./components/SeoContent";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";
import JsonLd from "@/components/base/JsonLd";
import { getWebsiteSchema, getOrganizationSchema, getBreadcrumbSchema } from "@/lib/schema";

export default function Home() {
  const websiteSchema = getWebsiteSchema();
  const organizationSchema = getOrganizationSchema();
  const breadcrumbSchema = getBreadcrumbSchema([
    { name: "Home", url: "https://hipobuyspread.online/" },
  ]);

  return (
    <>
      <JsonLd data={websiteSchema} />
      <JsonLd data={organizationSchema} />
      <JsonLd data={breadcrumbSchema} />
      <Navbar />
      <main>
        <Hero />
        <CategorySection />
        <WhySection />
        <SeoContent />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}